import {
  LISTA_JUSTIFICATIVAS_FALTA,
  LISTA_JUSTIFICATIVAS_FALTA_SUCESSO,
  CRIA_JUSTIFICATIVA_FALTA,
  CRIA_JUSTIFICATIVA_FALTA_SUCESSO,
  EDITA_JUSTIFICATIVA_FALTA,
  EDITA_JUSTIFICATIVA_FALTA_SUCESSO,
  REMOVE_JUSTIFICATIVA_FALTA,
  REMOVE_JUSTIFICATIVA_FALTA_SUCESSO,
  CALCULO_JUSTIFICATIVA_FALTA_SUCESSO,
  ADICIONA_ANEXOS_JUSTIFICATIVA_FALTA,
  ADICIONA_ANEXOS_JUSTIFICATIVA_FALTA_SUCESSO,
  REMOVE_ANEXO_JUSTIFICATIVA_FALTA,
  REMOVE_ANEXO_JUSTIFICATIVA_FALTA_SUCESSO,
  JUSTIFICATIVA_FALTA_ERRO,
  LIMPA_CONTEXTO_JUSTIFICATIVA_FALTA,
  BUSCA_NOTAS_FALTAS,
  LIMPAR_NOTAS_FALTAS,
  VOLTAR_PARA_FILTROS_NOTAS_FALTAS,
} from 'constants/ActionTypes';

const INIT_STATE = {
  // justificativas do contexto (matrícula/disciplina/etapa) aberto no modal
  contextoLista: [],
  carregandoContexto: false,
  salvando: false,
  salvandoAnexo: false,
  // override cirúrgico do cálculo: { [matriculaId]: { [componenteEscolaId]: faltasJustificadas } }
  // Quando há entrada para a matrícula, ela é autoritativa (componente ausente = 0 justificadas).
  calculoPorMatricula: {},
  erro: null,
};

const JustificativaFalta = (state = INIT_STATE, action) => {
  switch (action.type) {
    case LISTA_JUSTIFICATIVAS_FALTA:
      return { ...state, carregandoContexto: true, erro: null };

    case LISTA_JUSTIFICATIVAS_FALTA_SUCESSO:
      return {
        ...state,
        carregandoContexto: false,
        contextoLista: Array.isArray(action.payload) ? action.payload : [],
      };

    case CRIA_JUSTIFICATIVA_FALTA:
    case EDITA_JUSTIFICATIVA_FALTA:
    case REMOVE_JUSTIFICATIVA_FALTA:
      return { ...state, salvando: true, erro: null };

    case CRIA_JUSTIFICATIVA_FALTA_SUCESSO:
    case EDITA_JUSTIFICATIVA_FALTA_SUCESSO:
    case REMOVE_JUSTIFICATIVA_FALTA_SUCESSO:
      return { ...state, salvando: false };

    case ADICIONA_ANEXOS_JUSTIFICATIVA_FALTA:
    case REMOVE_ANEXO_JUSTIFICATIVA_FALTA:
      return { ...state, salvandoAnexo: true, erro: null };

    case ADICIONA_ANEXOS_JUSTIFICATIVA_FALTA_SUCESSO:
    case REMOVE_ANEXO_JUSTIFICATIVA_FALTA_SUCESSO:
      return { ...state, salvandoAnexo: false };

    case CALCULO_JUSTIFICATIVA_FALTA_SUCESSO: {
      const { matriculaId, porComponente } = action.payload || {};
      if (matriculaId === null || matriculaId === undefined) return state;
      return {
        ...state,
        calculoPorMatricula: {
          ...state.calculoPorMatricula,
          [matriculaId]: porComponente || {},
        },
      };
    }

    case JUSTIFICATIVA_FALTA_ERRO:
      return {
        ...state,
        salvando: false,
        salvandoAnexo: false,
        carregandoContexto: false,
        erro: action.payload || null,
      };

    case LIMPA_CONTEXTO_JUSTIFICATIVA_FALTA:
      return { ...state, contextoLista: [], carregandoContexto: false, erro: null };

    case BUSCA_NOTAS_FALTAS:
    case LIMPAR_NOTAS_FALTAS:
    case VOLTAR_PARA_FILTROS_NOTAS_FALTAS:
      return {
        ...state,
        calculoPorMatricula: {},
      };

    default:
      return state;
  }
};

export default JustificativaFalta;
